export const ROUTES = {
	home: '/workassignment',
	workassignment: '/workassignment',
	teams: '/teams',
	settings: '/settings',
};
